import { render, staticRenderFns } from "./NovoVigilante.vue?vue&type=template&id=219590dc&scoped=true"
import script from "./NovoVigilante.vue?vue&type=script&lang=js"
export * from "./NovoVigilante.vue?vue&type=script&lang=js"
import style0 from "./NovoVigilante.vue?vue&type=style&index=0&id=219590dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219590dc",
  null
  
)

export default component.exports